import { atomWithLocalStorage } from "common/storage/atomWithLocalStorage";
import { useAtom } from "jotai";
import { useEffect } from "react";

const darkModeAtom = atomWithLocalStorage<boolean>("isDarkMode", false);

export function useDarkMode() {
  const [isDarkMode, setIsDarkMode] = useAtom(darkModeAtom);

  useEffect(() => {
    const darkMode = window.matchMedia("(prefers-color-scheme: dark)");

    setIsDarkMode(darkMode.matches);
    if (darkMode.matches) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    const handler = (event: MediaQueryListEvent) => {
      setIsDarkMode(event.matches);
      if (event.matches) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    darkMode.addEventListener("change", handler);

    return () => {
      darkMode.removeEventListener("change", handler);
    };
  }, [setIsDarkMode]);

  return isDarkMode;
}
